<template>
  <div style="width: 90vw">
    <el-container class="contain-6" style="padding: 25px 25px">


      <div class="bbb">

        <el-header style="display: flex;height: 40px;">

          <span class="style-title">项目名称:</span>
          <el-select v-model="valueGame" placeholder="游戏选择" size="mini"
                     style="margin-left: 5px;margin-top: 5px;align-items: center;display: flex"
                     filterable clearable>
            <el-option
                v-for="item in optionsGame"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>


          <span class="style-title">投手:</span>
          <el-input v-model="person" placeholder="请输入投手" size="mini" clearable
                    style="margin-left: 5px;margin-top: 5px;width: 200px;align-items: center;display: flex">

          </el-input>

          <span class="style-title">时间:</span>
          <el-date-picker
              v-model="value1"
              type="datetime"
              style="margin-left: 5px;margin-top: 4px;width: 200px;align-items: center;display: flex"
              size="mini" clearable
              placeholder="选择日期时间">
          </el-date-picker>
          <el-button size="mini"
                     style="margin-left: 6px;height: 30px;margin-top:8px;background-color: #f4f4f5;color: black"
                     @click="search(true)" icon="el-icon-refresh">
            刷新
          </el-button>



        </el-header>
        <el-table
            ref="tableData1"
            :data="tableData"
            stripe
            border
            max-height="79vh"
            height="79vh"
            style="margin-top: 11px"
            :header-cell-style="{background:'rgb(244,244,245)',color:'#323335'}"
            size="mini"
            v-loading="loading"
            highlight-current-row

        >

          <el-table-column
              align="center"
              type="selection"
              width="44">
          </el-table-column>

          <el-table-column
              prop="gameName"
              label="游戏名"
              min-width="180"
              show-tooltip-when-overflow
          >

          </el-table-column>
          <el-table-column
              prop="promotionId"
              label="广告id"
              min-width="180"
          >

          </el-table-column>
          <el-table-column
              prop="tfPerson"
              label="投放人员"
              min-width="150"

          >

          </el-table-column>


          <el-table-column
              prop="statCost"
              label="消耗"
              min-width="130"
              sortable
          >

          </el-table-column>

          <el-table-column
              prop="f1HAmount"
              label="首小时ROI"
              min-width="130"
              sortable
          >

          </el-table-column>
          <el-table-column
              prop="yesterdayRoiYg"
              label="昨日广告预估24小时ROI（24小时消耗）"
              min-width="250"
              :formatter="value_format"

          >

          </el-table-column>

          <el-table-column
              prop="yesterdayBlYg"
              label="昨日广告预估24小时倍率（24小时消耗）"
              min-width="250"
          >

          </el-table-column>

          <el-table-column
              prop="today24Roi"
              label="今日广告预估24小时ROI（此点消耗）"
              min-width="250"
              :formatter="value_format"
          >

          </el-table-column>


          <el-table-column
              prop="yesterday24Roi"
              label="昨日广告预估24小时ROI（此点消耗）"
              min-width="250"
            :formatter="value_format"
          >

          </el-table-column>

          <el-table-column
              prop="today24Bl"
              label="今日广告预估24小时倍率（此点消耗）"
              min-width="250"

          >

          </el-table-column>

          <el-table-column
              prop="yesterday24Bl"
              label="昨日广告预估24小时倍率（此点消耗）"
              min-width="250"
          >

          </el-table-column>

          <el-table-column
              prop="seven24Bl"
              label="前七日游戏实际24小时倍率"
              min-width="180"
          >

          </el-table-column>

          <el-table-column
              prop="seven24Roi"
              label="前七日游戏实际24小时ROI"
              min-width="180"
              :formatter="value_format"
          >

          </el-table-column>
        </el-table>

        <div class="block">

          <el-pagination
              @current-change="search(true)"
              :current-page.sync="currentPage"
              :page-sizes="[25]"
              :page-size="100"
              layout="total, sizes, prev, pager, next, jumper"
              :total="400">
          </el-pagination>
        </div>
      </div>


    </el-container>

  </div>
</template>

<script>
export default {
  name: "GameBroad",

  data() {

    return {
      isSort: true,
      options2: ['+', '-', '*', '/'],
      newProp: '例如(进入游戏)',
      newPropValue: '',
      valProp2: '',
      valueSuan: '',
      colData: [{title: "账面消耗", istrue: true},
        {title: "实际消耗", istrue: false},
      ],
      colOptions: ["账面消耗"], //默认全选
      colSelect: ["账面消耗", "实际消耗"],
      valProp: '例如(1,下一关)',
      titleHeads: [{sta_value: "进入游戏", sta_view_value: "进入游戏"}, {
        sta_value: "下一关",
        sta_view_value: "进入下一关"
      }],
      list: [],
      value1: '',
      currentPage: 1,
      option_Scene: [{id: '总', value: ''}, {id: "抖音个人主页侧边栏", value: "_021001"},
        {id: '全局扫一扫', value: '_021002'}
        , {id: '抖音其他小游戏跳转', value: '_021009'}
        , {id: '抖音个人页我的小程序（个人简介下方）/ 抖音首页侧边栏', value: '_021036'}
        , {id: '抖音视频锚点', value: '_023001'}
        , {id: '抖音视频评论页锚点', value: '_023002'}
        , {id: '抖音直播间（仅自然转化，不包含发行人直播间投广告、投dou+）', value: '_023010'}
        , {id: '抖音搜索结果视频锚点', value: '_023023'}
        , {id: '抖音广告投放 （包含发行人直播间投广告、投dou+）', value: '_025001'}
        , {id: '抖极视频锚点', value: '_103001'}],
      valueScene: '',
      fl: false,
      loading: false,
      registerDate: "",
      type: 'pv',
      valueUser: "",
      avgEcpm: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      }, pickerOptions3: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }, pickerOptions2: {
        disabledDate(date) {
          return date.getTime() >= Date.now() - 8.64e7;  //只能选择今天及今天之后的日期，如果没有后面的-8.64e7就是今天也不能选
        }
      },
      tableData: [],
      tableData2: [],
    optionsGame: [],
      valueGame: "",
      options3: [{
        value: '选项1',
        label: '7'
      }, {
        value: '选项2',
        label: '14'
      }, {
        value: '选项3',
        label: '30'
      }],
      value: 0,

      ecpmA: 300,
      value2: '',
      value3: 7
      , json_data: []
      , json_fields: {},
      headType: '微信默认',
      height: 800,
      arr1: [],
      arr2: [],
      valueGame2: '',
      items: [],
      maxHeight:800

    }


  }, watch: {

  colOptions(valArr) {
    // alert("sss");
    var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
    this.colData.filter(i => {
      if (arr.indexOf(i.title) != -1) {
        i.istrue = false;
        this.$nextTick(() => {
          this.$refs.tableDataRef.doLayout();
        });
      } else {
        i.istrue = true;
        this.$nextTick(() => {
          this.$refs.tableDataRef.doLayout();
        });
      }
    });
  }
}, filters: {
    dataFilters(value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return  "-"

      } else if (value < 100) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }

    }
  }, methods: {

    indexMethod(index) {

      return index / 6 + 1;

    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 6 == 0) {
        return 'column-style2';
      } else {
        return 'column-style2';
      }
      // warning-row
    }, objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 6 === 0) {
          return {
            rowspan: 6,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    // 表头部重新渲染
    renderHeader(h, {column, $index}) {
      // 新建一个 span
      let span = document.createElement('span');
      // 设置表头名称
      span.innerText = column.label;
      // 临时插入 document
      document.body.appendChild(span);
      // 重点：获取 span 最小宽度，设置当前列，注意这里加了 20，字段较多时还是有挤压，且渲染后的 div 内左右 padding 都是 10，所以 +20 。（可能还有边距/边框等值，需要根据实际情况加上）
      column.minWidth = span.getBoundingClientRect().width + 20;
      // 移除 document 中临时的 span
      document.body.removeChild(span);
      return h('span', column.label);

    },
    addProp() {

      this.newPropValue = ''

      if (!this.arr1.includes(this.valProp))
        this.arr1.push(this.valProp + '_')

      if (this.valProp2 != '') {

        this.arr1.push(this.valProp2)
      }
      if (this.valueSuan != '') {

        this.arr2.push(this.valueSuan)

      }


      for (let i = 0; i < this.arr1.length; i++) {
        console.log(this.arr1[i]);

        this.newPropValue = this.newPropValue + this.arr1[i]

        if (this.arr2.length > i)
          this.newPropValue = this.newPropValue + this.arr2[i]

      }


    },
    date_format_new() {

      let date1 = new Date();

      let year = date1.getFullYear();
      // alert(year)
      let month = date1.getMonth() + 1;
      let day = date1.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;

      this.value2 = year + '' + month + '' + day;


    },

    up(e) {

      if (e == 0) {

        if (this.currentPage > 1)
          this.currentPage--
        this.searchPage()

      } else {

        this.currentPage++

        this.searchPage()
      }


    }, clickTo(row) {

      console.log(row)

    },

    getDiffDay() {
      let totalDays, diffDate
      let myDate_1 = Date.parse(this.value2)
      let myDate_2 = new Date()
      diffDate = Math.abs(myDate_1 - myDate_2)
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24))
      this.value3 = totalDays + 1
    },
    value_format(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0 || isNaN(value)) {

        return "-"
      } else {
        value = Math.round(value* 100)+'%'
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, value_format2(row, column, value) {
      // 截取当前数据到小数点后两位
      if (value == 0) {

        return "-"
      } else if (isNaN(value)) {

        return value == '' ? '-' : value

      } else if (value < 5) {

        return value

      } else {
        value = Math.round(value)
        value += ''
        if (!value.includes('.')) value += '.'
        return value.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
          return $1 + ','
        }).replace(/\.$/, '')
      }
    }, findGame() {

      this.$axios
          .get('/toufang/data/findName', {})
          .then(successResponse => {

            this.optionsGame = successResponse.data.data

          })


    },

    search(flag) {

      if(flag){

        console.log("手动选条件")

        localStorage.setItem("Game2", JSON.stringify({name: this.valueGame, date: this.value2}))

      }else{

        if (localStorage.getItem("Game2") != null) {

          console.log("自动刷")

          this.valueGame = JSON.parse(localStorage.getItem("Game2")).name

          this.value2 = JSON.parse(localStorage.getItem("Game2")).date


        }
      }

      this.maxHeight=window.innerHeight-250;

        this.$axios
            .post('/tf1/data/find', {

              gameName:this.valueGame,
              start:this.value2[0],
              end:this.value2[1],
              person:this.person==null?"":this.person,
              currentPage:this.currentPage

            })
            .then(successResponse => {
              this.tableData=successResponse.data.data.data

              console.log(successResponse.data.data)


              this.loading = false

            })




    },

  }
  , updated() {

    this.$nextTick(() => {
      this.$refs['tableData1'].doLayout();
    })

  },
  mounted: function () {
    this.height = window.innerHeight;
    this.maxHeight=window.innerHeight-250;
      // this.date_format_new()


    this.findGame()
    this.search(false)
    for (let i = 0, len = 160; i <= 160; i++) {
      this.items.push(i + '')
    }
  }


}
</script>
<style>
.el-table .column-style {
  color: #4d7dd6;
  font-size: 12px;
  font-weight: bold;
}

.el-table .column-style3 {
  color: #d65055;
  font-size: 12px;
  font-weight: 600;
}

.el-table .column-style2 {
  color: #606266;
  font-size: 12px;

  border: 2px dashed #F00;
  border-right: 2px dashed #0F0 !important;
}

.el-progress-bar .el-progress-bar__inner {

  border-radius: inherit;

}

.el-progress-bar .el-progress-bar__outer {
  background-color: rgba(134, 116, 255, 0.54);
  border-radius: inherit;

}



.item {
  margin-top: 8px;
  margin-right: 10px;
  padding: 2px 2px;
}
</style>
<style type="text/css">

*::-webkit-scrollbar {
  width: 13px;
  height: 12px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: #f0f6ff;
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #b1b2b3;

}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none
}

.scrollbarShow::-webkit-scrollbar {
  display: block
}

.bbb {
  //box-shadow: rgba(148,148,148,0.34) 0px 1px 3px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .08);
  padding: 24px;
  border-radius: 8px;
  background-color: #FFFFFF;
  width: 98%;

  margin-top: 19px;
  min-height: 80vh;
}

</style>


<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

/deep/ .el-range-input {
  background-color: rgba(240, 240, 240, 0.94);

}
</style>